"use client";

import DynamicColumns from "@/app/shared/components/layout/DynamicColumns";

/**
 * ─── Main Component ───────────────────────────────────────────────────────────
 * * This component now relies entirely on DynamicColumns to fetch and render
 * the footer layout designed in the admin panel. 
 * * If no configuration exists for a page, DynamicColumns will handle its 
 * own internal null state.
 */
const Footer = () => {
  return (
    <footer>
      <DynamicColumns
        section="footer"
        className="bg-[#98AFC7]"
        innerClassName="px-4 py-8"
        // Fallback prop removed: Static category links and 
        // hardcoded copyright sections have been deleted.
      />
    </footer>
  );
};

export default Footer;